import { IGetUserInfo, ICreateUser, IUpdateUser, IGetPaginatedUsers, IUsers } from 'types';
import { AxiosResponse } from 'axios';
import { request } from '../index';

const serviceGetUserInfo = (userID: string): Promise<IGetUserInfo> => {
	return request({ typeOfRequest: 'getWithToken', url: `/api/Users/${userID}` });
};

const serviceCreateUser = (data: ICreateUser): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'postWithToken', url: `/api/Users`, data });
};

const serviceUpdateUser = (data: IUpdateUser): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'putWithToken', url: `/api/Users/${data.id}`, data });
};

const serviceGetPaginatedUsers = (args: IGetPaginatedUsers): Promise<AxiosResponse<IUsers>> => {
	return request({ typeOfRequest: 'postWithToken', url: `/api/Users/filtered`, data: args });
};

const serviceDeleteUser = (userID: string): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'deleteWithTokenAndWithParameterInUrlLine', url: `/api/Users/${userID}` });
};

export { serviceGetUserInfo, serviceCreateUser, serviceUpdateUser, serviceGetPaginatedUsers, serviceDeleteUser };
